import { useEffect, useState } from "react";
import axios from "axios";
import { Mail } from "lucide-react";
import { fmtDate } from "./LeadDetail";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DigestPanel = ({ token }) => {
  const [info, setInfo] = useState(null);
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState(null);
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => axios.get(`${API}/admin/digest`, { headers }).then(({ data }) => setInfo(data));
  useEffect(() => {
    axios.get(`${API}/admin/digest`, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => setInfo(data));
  }, [token]);

  const sendNow = async () => {
    setSending(true);
    setMsg(null);
    try {
      const { data } = await axios.post(`${API}/admin/digest/send`, {}, { headers });
      setMsg({ ok: true, text: `Inviato a ${data.sent_to}: ${data.new_leads} nuovi lead, ${data.overdue} richiami scaduti, ${data.upcoming} in programma.` });
      load();
    } catch (err) {
      const d = err.response?.data?.detail;
      setMsg({ ok: false, text: typeof d === "string" ? d : "Invio non riuscito." });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-white border hairline p-8" data-testid="digest-panel">
      <p className="font-sans-ui text-[10px] tracking-mega text-ink/40 mb-3">RIEPILOGO SETTIMANALE</p>
      <h2 className="font-display text-3xl text-ink mb-2">Ogni lunedì alle 9:00</h2>
      <p className="font-sans-ui text-[13px] text-ink/60 leading-relaxed mb-6">
        Email automatica con i nuovi lead degli ultimi 7 giorni, i richiami scaduti e in programma, e i conteggi per stato.
      </p>
      <dl className="grid grid-cols-2 gap-4 font-sans-ui text-[13px] mb-6">
        <div>
          <dt className="text-[10px] tracking-mega text-ink/40 mb-1">DESTINATARIO</dt>
          <dd className="text-ink/80 break-all" data-testid="digest-recipient">{info?.recipient || "—"}</dd>
        </div>
        <div>
          <dt className="text-[10px] tracking-mega text-ink/40 mb-1">PROSSIMO INVIO</dt>
          <dd className="text-ink/80" data-testid="digest-next-run">{info?.next_run_at ? fmtDate(info.next_run_at) : "—"}</dd>
        </div>
        <div className="col-span-2">
          <dt className="text-[10px] tracking-mega text-ink/40 mb-1">ULTIMO INVIO</dt>
          <dd className="text-ink/80" data-testid="digest-last-sent">
            {info?.last_sent_at ? `${fmtDate(info.last_sent_at)} · ${info.last_trigger === "manual" ? "manuale" : "automatico"}` : "Mai inviato"}
          </dd>
        </div>
      </dl>
      <button data-testid="digest-send-button" onClick={sendNow} disabled={sending} className="inline-flex items-center gap-2 bg-ink text-ivory px-6 py-3 text-[10px] tracking-mega font-semibold hover:bg-charcoal transition-colors disabled:opacity-50">
        <Mail size={13} /> {sending ? "INVIO..." : "INVIA ORA"}
      </button>
      {msg && <p data-testid="digest-send-message" className={`mt-4 font-sans-ui text-sm ${msg.ok ? "text-emerald-700" : "text-destructive"}`}>{msg.text}</p>}
    </div>
  );
};
